document.addEventListener('DOMContentLoaded', (event) => {
    // console.log("test111122");
    const element = document.querySelector('[id$="__afterpay_on_site_messaging_payments_messaging_KEFtHD"]');
    if (element) {
        // console.log("afterppppp")
        element.style.display = 'none';
    }
});
